module.exports = __webpack_public_path__ + "img/kaka.0981e3da.png";